import { createAsyncThunk } from "@reduxjs/toolkit"

import apiClient from "src/apiClient"

import economyReducers from "../reducers"
import { walletFromResponse } from "./getWallet"

// The endpoint answers with the whole wallet, not just the amount granted, so one round trip both
// pays the player and leaves every screen showing the new balance. A 409 (already claimed today)
// reaches the caller through `.unwrap()`, which is how the button words it.
export const thunk = createAsyncThunk("economy/claimDaily", async (_, { rejectWithValue }) => {
  try {
    const response = await apiClient.post("/credits/daily/")
    return { ...walletFromResponse(response.data), granted: response.data.granted }
  } catch (error) {
    return rejectWithValue(error.response?.data)
  }
})

export const onSucceed = economyReducers.setData

const thunkObject = { thunk, onSucceed }
export default thunkObject
